import {inject} from '@angular/core';
import {CanActivateFn, Router, UrlTree} from '@angular/router';
import {WebmateOptions} from '@webmate-web-core/webmate-options';

export const signUpGuard: CanActivateFn = (): boolean | UrlTree => {
    const webmateOptions = inject(WebmateOptions);
    const router = inject(Router);

    if (webmateOptions.demoenv) {
        return true;
    } else {
        return router.createUrlTree(['login']);
    }
}
